
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"66","height":"58","viewBox":"0 0 66 58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.925 42.05l3-6.5-5.32-12.06h2.63l3.84 9.25 3.73-9.25h2.74l-8.13 18.56h-2.49zM1.155 31.71a10.78 10.78 0 010-9.71 10.81 10.81 0 019.66-6 10.4 10.4 0 017.24 2.82l-3.09 3.08a5.88 5.88 0 00-4.15-1.57 6.53 6.53 0 00-6.4 6.66c.01.66.121 1.315.33 1.94a6.59 6.59 0 009.8 3.4 5.002 5.002 0 002.16-3.29h-5.89V24.9h10.2c.128.727.191 1.463.19 2.2a10.581 10.581 0 01-3.22 8 10.32 10.32 0 01-7.17 2.61 10.8 10.8 0 01-9.66-6zm41.08 3.82a4.059 4.059 0 01-1.43-3.2 3.82 3.82 0 011.51-3.18 6.43 6.43 0 014-1.18 7.06 7.06 0 013.55.79v-.56a2.73 2.73 0 00-1-2.14 3.4 3.4 0 00-2.32-.84 3.709 3.709 0 00-3.21 1.71l-2.12-1.34a5.92 5.92 0 015.2-2.52 6 6 0 014.23 1.43 5.08 5.08 0 011.55 3.93v7.9h-2.29v-1.75h-.11a4.621 4.621 0 01-4 2.21 5.22 5.22 0 01-3.56-1.26zm2.06-4.87a2.119 2.119 0 00-1 1.77 1.92 1.92 0 00.8 1.58 3 3 0 001.88.63 3.9 3.9 0 002.72-1.13 3.55 3.55 0 001.2-2.66 4.94 4.94 0 00-3.16-.9 4.11 4.11 0 00-2.44.71zm-15.75 5.67V17.54h6.42a5.83 5.83 0 014.15 1.63 5.449 5.449 0 010 8 5.742 5.742 0 01-4.15 1.6h-4v7.56h-2.42zm2.42-16.51v6.61h4.06a3.17 3.17 0 002.39-1 3.21 3.21 0 00.06-4.54l-.06-.06a3.179 3.179 0 00-2.39-1l-4.06-.01z"}})])
          )
        }
      }
    